// extracted by mini-css-extract-plugin
export default {"widgetShell":"widgetProjectRoutes_widgetShell__nXFiQ"};